<template>
  <a-input-search
    v-model:value="innerValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    :allow-clear="allowClear"
    :loading="loading"
    :enter-button="enterButton"
    :status="status"
    class="ant-search-input"
    @search="onSearch"
    @blur="onBlur"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  loading?: boolean;
  enterButton?: boolean | string;
  status?: "" | "error" | "warning";
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "Tìm kiếm...",
  disabled: false,
  size: "middle",
  allowClear: true,
  loading: false,
  enterButton: false,
  status: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "search", value: string, event?: Event): void;
  (e: "blur", event: FocusEvent): void;
  (e: "change", value: string): void;
}>();

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onSearch = (value: string, event?: Event) => {
  emit("search", value, event);
};

const onBlur = (e: FocusEvent) => emit("blur", e);
</script>

<!--
  Hướng dẫn sử dụng — Search
  Global: <h-search v-model="keyword" enter-button @search="onSearch" />
  Import: import { SearchInput } from '@/components/ant/input'

  Props: modelValue, placeholder, disabled, size, allowClear, loading, enterButton, status
  Events: update:modelValue, search, change, blur
  Docs: src/components/ant/input/README.md
-->
